import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => {
    return {
        ng1DrillDown: {
            '&': {
                padding: 0,
            },
        },
    };
});

export default useStyles;
